import { Select } from "@mantine/core";
import { ValueLabelPair } from "./FiltersMenu";

interface OperationSelectProps {
  operations: ValueLabelPair[];
  value?: string | null;
  onChange?: (value: string | null) => void;
}

const OperationSelect: React.FC<OperationSelectProps> = ({
  operations,
  value = null,
  onChange,
}) => {
  const handleChange = (val: string | null) => {
    onChange?.(val);
  };
  return (
    <Select
      radius="md"
      mx={5}
      mb={5}
      placeholder="Pick preset ranges"
      value={value}
      onChange={handleChange}
      data={operations}
      sx={{
        input: {
          backgroundColor: "#F9FAFB",
          ":focus": {
            borderColor: "#b1b1b1;",
          },
        },
      }}
    />
  );
};

export default OperationSelect;

